import React from "react";
import styled from "styled-components";
import { Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";

import { FORM_FIELD_KEYS } from "../../../../../constants/forms";
import { getFieldProps } from "../../../../../utils/form-fields";
import { hexToRGBA } from "../../../../../utils/theme";

import TextInput from "../../../controls/TextInput";
import MaskInput from "../../../controls/MaskInput";
import Select from "../../../controls/Select";

const StyledContainer = styled.div`
  margin-bottom: 24px;
  border: 1px solid ${hexToRGBA('#000000', 0.1)};

  label[for='legalName'] {
    width: 100%;
  }
`;

const StyledRow = styled(Row)`
  padding: 16px;
`;

function PrincipalOfficerInfoBlock({ values = {}, onChange, onMouseEnter, onMouseLeave }) {
  return (
    <StyledContainer>
      <div className="inputs-block-title">
        <span>Principal Officer Information</span>
      </div>
      <StyledRow>
        <Col xs={12}>
          <Select
            {...getFieldProps(FORM_FIELD_KEYS.principalOfficerTitle)}
            label={getFieldProps(FORM_FIELD_KEYS.principalOfficerTitle)?.placeholder?.replace("*", "")}
            placeholder={getFieldProps(FORM_FIELD_KEYS.principalOfficerTitle)?.placeholder?.replace("*", "")}
            value={values[FORM_FIELD_KEYS.principalOfficerTitle]}
            validated={values.validated}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.principalOfficerFirstName)}
            label={getFieldProps(FORM_FIELD_KEYS.principalOfficerFirstName)?.placeholder?.replace("*", "")}
            placeholder={undefined}
            value={values[FORM_FIELD_KEYS.principalOfficerFirstName]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.principalOfficerMiddleName)}
            label={getFieldProps(FORM_FIELD_KEYS.principalOfficerMiddleName)?.placeholder?.replace("*", "")}
            placeholder={undefined}
            value={values[FORM_FIELD_KEYS.principalOfficerMiddleName]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.principalOfficerLastName)}
            label={getFieldProps(FORM_FIELD_KEYS.principalOfficerLastName)?.placeholder?.replace("*", "")}
            placeholder={undefined}
            value={values[FORM_FIELD_KEYS.principalOfficerLastName]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12}>
          <Select
            {...getFieldProps(FORM_FIELD_KEYS.principalOfficerSuffixName)}
            label={getFieldProps(FORM_FIELD_KEYS.principalOfficerSuffixName)?.placeholder?.replace("*", "")}
            placeholder={getFieldProps(FORM_FIELD_KEYS.principalOfficerSuffixName)?.placeholder?.replace("*", "")}
            value={values[FORM_FIELD_KEYS.principalOfficerSuffixName]}
            validated={values.validated}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12}>
          <MaskInput
            {...getFieldProps(FORM_FIELD_KEYS.principalOfficerSSN)}
            label={(
              <>
                Social Security Number&nbsp;
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 0, hide: 0 }}
                  trigger={["hover", "click"]}
                  overlay={(
                    <Tooltip id={`tooltip-${FORM_FIELD_KEYS.principalOfficerSSN}-subhint`} className="subhintTooltipFederal">
                      <span>
                        In order to assign an EIN for an Entity, the IRS requires the Social Security Number of the managing member. 
                        This information is secured with SSL encryption.
                      </span>
                    </Tooltip>
                  )}
                >
                  <a className="ssn-subhint-title">
                    Why is this needed?
                  </a>
                </OverlayTrigger>
              </>
            )}
            placeholder={getFieldProps(FORM_FIELD_KEYS.principalOfficerSSN)?.placeholder?.replace("*", "")}
            value={values[FORM_FIELD_KEYS.principalOfficerSSN]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            hideDivider
          />
        </Col>
      </StyledRow>
    </StyledContainer>
  );
}

export default PrincipalOfficerInfoBlock;
